import React from 'react';

const clauses = [
  {
    title: 'Artikel 1 — Partijen en KvK-nummer',
    text: 'Opdrachtnemer: Pieter van der Berg, Keizersgracht 123, 1015 CJ Amsterdam, KvK-nummer 12345678, btw-nummer NL123456789B01. Opdrachtgever: TechBedrijf BV, Herengracht 456, 1017 CA Amsterdam, KvK-nummer 87654321. Beide partijen zijn ingeschreven bij de Kamer van Koophandel en handelen in overeenstemming met het Nederlands recht.',
  },
  {
    title: 'Artikel 2 — Vergoeding en BTW',
    text: 'Opdrachtgever betaalt Opdrachtnemer een uurtarief van € 95,00 (vijfennegentig euro), exclusief BTW (21%). Opdrachtnemer is btw-plichtig en zal facturen uitreiken conform de Nederlandse Wet op de Omzetbelasting. Facturen dienen te worden voldaan binnen 30 dagen na factuurdatum. Bij overschrijding van de betalingstermijn is de wettelijke handelsrente verschuldigd conform artikel 6:119a BW.',
  },
  {
    title: 'Artikel 3 — Toepasselijk Recht en Bevoegde Rechtbank',
    text: 'Op deze overeenkomst is uitsluitend Nederlands recht van toepassing. Geschillen die voortvloeien uit of verband houden met deze overeenkomst worden voorgelegd aan de bevoegde rechter in het arrondissement Amsterdam. Partijen zullen eerst trachten een geschil in onderling overleg op te lossen.',
  },
  {
    title: 'Artikel 4 — ZZP-status en Wet DBA',
    text: 'Opdrachtnemer is een zelfstandige zonder personeel (ZZP\'er) en handelt als ondernemer in de zin van de Wet Deregulering Beoordeling Arbeidsrelaties (Wet DBA). Er is geen sprake van een arbeidsovereenkomst. Opdrachtnemer is zelf verantwoordelijk voor de afdracht van belastingen en premies volksverzekeringen.',
  },
];

const NetherlandsExampleClauses = () => (
  <section className="mb-12">
    <h2 className="text-2xl font-bold text-[#2F4E6F] mb-6">Voorbeeldclausules voor een ZZP contract in Nederland</h2>
    <div className="space-y-4">
      {clauses?.map((clause, i) => (
        <div key={i} className="border border-gray-200 rounded-xl bg-white p-6 shadow-sm">
          <h3 className="font-bold text-[#2F4E6F] mb-3">{clause?.title}</h3>
          <p className="text-gray-600 leading-relaxed text-sm">{clause?.text}</p>
        </div>
      ))}
    </div>
  </section>
);

export default NetherlandsExampleClauses;
